import React from 'react'
import _ from 'lodash';
import { NavLink } from 'reactstrap';
import LottieViewer from '../../../../components/LottieViewer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const businessDetails = [
  {
    title: 'Crediwatch for Commercial Lenders',
    img: `${process.env.REACT_APP_CDN_URL}/assets/lottie/public-home/commercial-lenders.json`,
    description: "Assess and monitor borrowers financial health and price risk accurately. Reduce NPAs and grow your loan portfolio with the right set of borrowers.",
    details: [],
    links: [
      { name: "Enhanced Credit Reports" },
      { name: "Early Warning System" },
      { name: "Trust Score Report" }
    ],
    urls: [
      {
        name: "Enhanced Credit Reports",
        urlPath: "enhancedCreditReports",
        url: `https://about.crediwatch.com/product/enhanced-credit-reports/`
      },
      {
        name: "Early Warning System",
        urlPath: "earlyWarningSystems",
        url: `https://about.crediwatch.com/product/early-warning-systems/`
      },
      {
        name: "Trust Score Report",
        urlPath: "trustScore",
        url: `https://about.crediwatch.com/product/trustscore/`
      },
    ]
  },
  {
    title: "Crediwatch for Businesses",
    img: `${process.env.REACT_APP_CDN_URL}/assets/lottie/public-home/businesses.json`,
    description: "Evaluate the risk associated with your vendors, suppliers or partners. Access alternate data driven insights to make credit related decisions.",
    details: [
      { name: "View and download financial information" },
      { name: "Uncover complex holding structures" },
      { name: "Observe GST, EPF filing trends" }
    ],
    links: [
      {}
    ],
    urls: [
      {
        name: "Sign Up",
        urlPath: "signUp",
        url: "https://account.crediwatch.com/signup"
      }
    ]

  },
  {
    title: "Crediwatch for Law firms",
    img: `${process.env.REACT_APP_CDN_URL}/assets/lottie/public-home/law-firms.json`,
    description: "Equip yourself with a compehensive data library of over 12 million business entities accross the country. Get access to regulatory filings, court cases filed in the conventional courts, appellate courts, tribunals and other public forums",
    details: [],
    links: [
      { name: "Sign Up" },
    ],
    urls: [
      {
        name: "Sign Up",
        urlPath: "signUp",
        url: "https://account.crediwatch.com/signup"
      }
    ]

  }

]
const BusinessDetails = () => {
  return (
    <div>
      {
        businessDetails.map((each, index) => {
          return (
            <div className='row' key={index}>
              <div className='col-lg-6 col-12'>
                <div className='d-flex justify-content-center h-100 flex-column mt-3 pt-2'>
                  <div className='text center business-details-title ff-renner-bold'>
                    {each.title}
                    <div className='line text-primary bg-primary mt-4' />
                  </div>
                  <div className='business-details-description b-2 ff-renner-book mt-4'>
                    {each.description}
                  </div>
                  <div className='mt-3'>
                    {
                      _.isArray(each.details) && (
                        each.details.map(a => <li className='ff-renner-semi mt-2'>{a.name}</li>)
                      )
                    }
                  </div>
                  <div className='d-flex flex-column mt-4'>
                    {_.isArray(each.urls) &&
                      each.urls.map(a =>
                        <NavLink href={`${a.url}`} className='mb-1 ff-renner-semi p-0 mt-2 align-self-left' >
                          {`${a.name} `}
                          <FontAwesomeIcon icon={faArrowRight} />
                        </NavLink>
                      )
                    }
                  </div>
                </div>
              </div>
              <div className='col-lg-6 col-12 mt-4'>
                <div className='d-flex align-items-center justify-content-center h-100'>
                  <LottieViewer location_path={each.img} />
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}
export default BusinessDetails
